import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-107">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-108">
        <p className="text-gray-400 font-bold" data-id="element-109">
          Metodo Economia Aziendale Pro™ — Il sistema N.1 per Docenti di
          Economia Aziendale nella Scuola Secondaria Italiana.
        </p>
        <p data-id="element-110">
          Materiale didattico conforme alle Indicazioni Nazionali e al Quadro di
          Riferimento del Ministero dell'Istruzione e del Merito (MIM)
          2025/2026.
        </p>
        <p data-id="element-111">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-112">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-113">
          © Metodo Economia Aziendale Pro™ — Sistema Didattico Integrato 2026
          — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}